export const TAB_REGISTER = 0;
export const TAB_LOGIN = 1;
export const TAB_PASSWORD_RESET = 2;
